import React from 'react';
import ReportFrame from '../ReportFrame';

export default class OfficeGrossProfitReport extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Office Gross Profit'
          reportParams={reportParams}
          id='officegrossprofitreport'
          name='officegrossprofitreport'
          title='Office Gross Profit'
        />
      </div>
    );
  }
}
